import pluralize from 'pluralize';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';
import { actions, type AppDispatch, selectors } from 'state';
import { Alert } from 'components/common';
import { ExclamationCircleIcon } from 'icons';

const StaleComparedProductsBanner = () => {
  const dispatch = useDispatch<AppDispatch>();
  const removedCount = useSelector(selectors.products.getStaleComparedProductsCount);
  const onClose = () => dispatch(actions.products.resetStaleCompared());

  if (!removedCount) return null;

  return (
    <Alert isDismissable onClose={onClose} variant="error">
      <ExclamationCircleIcon className="flex-shrink-0 text-red" height="24" width="24" />
      <span className="ps-2 pe-3">
        {pluralize('product', removedCount, true)} you selected {pluralize('was', removedCount)} updated and removed
        from the list.
        <span>
          {' '}
          <Link to="/rates/products">Go back to Rates</Link> to select the updated products.
        </span>
      </span>
    </Alert>
  );
};

export default StaleComparedProductsBanner;
